import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { PageHead, TableSkeleton, StatusBadge } from "./ui";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function AdminServices() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");

  const load = () => { setData(null); api.get("/admin/services").then((r) => setData(r.data)); };
  useEffect(() => { load(); }, []);

  const toggle = async (s) => {
    await api.put(`/admin/services/${encodeURIComponent(s.name)}`, { disabled: s.status !== "Disabled" });
    toast.success(`${s.name} ${s.status !== "Disabled" ? "disabled" : "enabled"}`);
    load();
  };

  const rows = (data?.services || []).filter((s) => s.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="admin-services">
      <PageHead title="Services" subtitle={`${data?.total || 0} specialties across the catalog`} />
      <Input placeholder="Search specialty…" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-xs mb-4" data-testid="service-search" />
      <div className="rounded-2xl bg-white p-4 shadow-sm border border-black/5">
        {!data ? <TableSkeleton /> : (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader><TableRow>
                <TableHead>Name</TableHead><TableHead>Category</TableHead><TableHead>Providers</TableHead>
                <TableHead>Bookings</TableHead><TableHead>Savings</TableHead><TableHead>Status</TableHead>
                <TableHead className="text-right">Actions</TableHead>
              </TableRow></TableHeader>
              <TableBody>
                {rows.map((s) => (
                  <TableRow key={s.name} data-testid={`service-row-${s.name}`}>
                    <TableCell className="font-medium">{s.name}</TableCell>
                    <TableCell className="text-muted-foreground">{s.category}</TableCell>
                    <TableCell>{s.provider_count > 0 ? s.provider_count : <span className="text-amber-600 text-xs font-semibold">Coming Soon</span>}</TableCell>
                    <TableCell>{s.bookings}</TableCell>
                    <TableCell className="text-xs">{s.savings_range}</TableCell>
                    <TableCell><StatusBadge status={s.status} /></TableCell>
                    <TableCell className="text-right">
                      <Button size="sm" variant="outline" onClick={() => toggle(s)} data-testid={`service-toggle-${s.name}`}>
                        {s.status === "Disabled" ? "Enable" : "Disable"}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </div>
    </div>
  );
}
